import { v4 as uuidv4 } from 'uuid';

export class WROption
{
    id: string;
    optionText: string;
    optionResult: number;

    constructor(optionText: string = "", optionResult: number = 0)
    {
        this.id = uuidv4();
        this.optionText = optionText;
        this.optionResult = optionResult;
    }
}
